import * as React from "react";

/**
 * ¿Este aparato puede hacer una foto?
 *
 * Se mira la CAPACIDAD del puntero, no el ancho de la ventana. `useIsMobile`
 * responde "sí" a cualquier ventana de menos de 1024 px, y eso aquí miente en
 * las dos direcciones: un portátil con la ventana estrecha sigue sin tener
 * cámara a la que apuntar, y un tablet ancho sí la tiene.
 *
 * `(pointer: coarse)` = el puntero principal es un dedo (teléfono o tablet).
 * `(pointer: fine)` = ratón o lápiz de precisión, es decir, un ordenador.
 */
export function useIsTouchDevice(): boolean {
  const query = "(pointer: coarse)";
  const [touch, setTouch] = React.useState<boolean>(() =>
    typeof window !== "undefined" && typeof window.matchMedia === "function"
      ? window.matchMedia(query).matches
      : false,
  );

  React.useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;
    const mql = window.matchMedia(query);
    const onChange = () => setTouch(mql.matches);
    mql.addEventListener("change", onChange);
    onChange();
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return touch;
}
